import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor($scope, $timeout) {
        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    $onChanges() {
        this.init();
    }

    $onInit() {
        this.init();
        this.$timeout(() => this.watch());
    }

    init() {
        this.$model = this.applicationConfiguration;
        this.model = angular.copy(this.$model);
        this.applicationNamePattern = /^[^@]/;
    }

    notModified() {
        return angular.equals(this.$model, this.model);
    }

    onKeyUp($event) {
        if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
            this.onEnter();
        }
    }

    watch() {
        this.$scope.$watch(
            () => this.model,
            () => {
                if (this.model.isEPM && this.model.epmAppSettings.canUserSetPassword) {
                    this.model.epmAppSettings.canUserViewPassword = true;
                }
                this.$timeout(() => this.onChange({$value: this.model, $invalid: this.form.$invalid}));
            },
            true
        );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration-form.controller.js